
import Vue from 'vue'
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar';
Vue.component('v-chart', ECharts);
